import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_DELIVERY_POINT_APP_PATHS } from '../constants/delivery-points-app-paths.constants';
import AdminDeliveryPointsListView from '../views/admin/AdminDeliveryPointsList.view';
import AdminDeliveryPointDetailsView from '../views/admin/AdminDeliveryPointDetails.view';

export default function AdminDeliveryPointsRoutes() {
  return (
    <React.Fragment>
      <Route
        exact
        path={ADMIN_DELIVERY_POINT_APP_PATHS.DELIVERY_POINTS_LIST}
        component={AdminDeliveryPointsListView}
      />
      <Route
        exact
        path={ADMIN_DELIVERY_POINT_APP_PATHS.DELIVERY_POINT_DETAILS}
        component={AdminDeliveryPointDetailsView}
      />
    </React.Fragment>
  );
}
